/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListPromo from '../views/promo/ListPromo.vue';
import AddPromo from '../views/promo/AddPromo.vue';
import { setBreadcrumb } from './index';

const promoRoute = {
  path: '/promo',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Promo',
        appBarTitle: 'Promo',
        breadcrumbs: () => [
          setBreadcrumb('Promo', '/promo', true),
          setBreadcrumb('List Promo', '/promo'),
        ],
      },
      component: ListPromo,
      name: 'ListPromo',
    },
    {
      path: '/promo/add',
      meta: {
        title: 'BNI QRIS - Add Promo',
        appBarTitle: 'Add Promo',
        breadcrumbs: () => [
          setBreadcrumb('Promo', '/promo', true),
          setBreadcrumb('List Promo', '/promo'),
          setBreadcrumb('Add Promo', '/promo/add'),
        ],
      },
      component: AddPromo,
      name: 'AddPromo',
    },
    {
      path: '/promo/edit/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Edit Promo',
        appBarTitle: 'Edit Promo',
        breadcrumbs: () => [
          setBreadcrumb('Promo', '/promo', true),
          setBreadcrumb('List Promo', '/promo'),
          setBreadcrumb('Edit Promo', '/promo/edit'),
        ],
      },
      component: AddPromo,
      name: 'EditPromo',
    },
  ],

  meta: {
    title: 'BNI QRIS - Promo',
    appBarTitle: 'Promo',
  },
  component: Parent,
};
export default promoRoute;
